import React from "react";
import "../css/enviotrabajos.css";

export default function EnvioTrabajos() {
  return (
    <div className="envio-container">
      <h1 className="titulo margin">Envío de trabajos</h1>

      {/* Modalidad */}
      <section className="card">
        <h2>Modalidad de participación</h2>

        <p>
          La modalidad de participación es como <b>Asistente</b> o mediante la
          <b> Presentación de un trabajo</b> sobre plantas medicinales en
          cualquiera de las áreas temáticas descritas anteriormente.
        </p>

        <p>Los trabajos pueden presentarse en modalidad:</p>

        <ul>
          <li>
            <p>
              {" "}
              Presentación <b> Oral</b>
            </p>
          </li>
          <li>
            <p>
              <b>Póster</b> (afiche o cartel)
            </p>
          </li>
        </ul>

        <p>
          Los trabajos de <b>pregrado en ejecución</b> se presentarán bajo
          modalidad de póster. Los trabajos terminados de pregrado o en
          ejecución de posgrado participarán en un proceso de selección para
          presentación oral.
        </p>
      </section>

      {/* Instrucciones */}
      <section className="card">
        <h2>Instrucciones para la preparación de los resúmenes</h2>

        <p>
          Para participar con un trabajo de investigación se debe enviar un
          resumen de acuerdo con el modelo que será proporcionado próximamente.
        </p>

        <ol>
          <li>Debe estar redactado en español, inglés o portugués.</li>

          <li>
            El resumen debe presentarse en una página tamaño carta, márgenes
            superior e inferior de 2.5 cm y laterales de 3 cm, en Word, letra
            Arial 10 y espaciado simple.
          </li>

          <li>El título del resumen está limitado a 20 palabras.</li>

          <li>
            Autores y afiliación centrados. Debe indicarse el correo electrónico
            del autor de correspondencia.
          </li>

          <li>
            El texto del resumen podrá tener hasta 300 palabras y debe estar
            justificado con interlineado sencillo.
          </li>

          <li>
            Debe contener introducción, metodología, resultados, conclusión y 3
            o 4 palabras clave.
          </li>

          <li>
            Debe corresponder a cualquiera de las 10 áreas temáticas del
            congreso.
          </li>

          <li>
            Los resúmenes serán revisados por el comité científico para su
            selección.
          </li>

          <li>
            Modalidades de presentación:
            <ul>
              <li>Oral (10 minutos)</li>
              <li>Póster (110 cm x 90 cm)</li>
            </ul>
          </li>
        </ol>
      </section>

      {/* Fechas */}
      <section className="card">
        <h2>Fechas límite para el envío de resúmenes</h2>

        <div className="fechas">
          <div className="fecha">
            <h3>1er envío</h3>
            <p>Hasta el 15 de mayo de 2026</p>
            <span>(Recomendado para presentación oral)</span>
          </div>

          <div className="fecha">
            <h3>2do envío</h3>
            <p>Hasta el 15 de julio de 2026</p>
          </div>

          <div className="fecha">
            <h3>3er envío</h3>
            <p>Hasta el 15 de septiembre de 2026</p>
          </div>
        </div>
      </section>

      {/* Costos */}
      <section className="card">
        <h2>Costos para participantes que presenten trabajos</h2>

        <h3>Hasta el 15 de julio de 2026</h3>

        <table className="tabla">
          <thead>
            <tr>
              <th>Tipo de participante </th>
              <th>Costo </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <p>Estudiante de pregrado </p>
              </td>
              <td>
                <p>USD 50 </p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Estudiante de posgrado </p>
              </td>
              <td>
                <p>USD 60 </p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Profesional </p>
              </td>
              <td>
                <p>USD 80 </p>
              </td>
            </tr>
          </tbody>
        </table>

        <h3>A partir del 16 de julio de 2026</h3>

        <table className="tabla">
          <thead>
            <tr>
              <th>Tipo de participante</th>
              <th>Costo</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <p>Estudiante de pregrado</p>
              </td>
              <td>
                <p>USD 60</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Estudiante de posgrado</p>
              </td>
              <td>
                <p>USD 70</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Profesional</p>
              </td>
              <td>
                <p>USD 90</p>
              </td>
            </tr>
          </tbody>
        </table>
      </section>

      {/* Botón */}
      <div className="envio-boton">
        <button>Enviar resumen</button>
      </div>

      <p className="tag-envio">
        The Microsoft CMT service was used for managing the peer-reviewing
        process for this conference. This service was provided for free by
        Microsoft and they bore all expenses, including costs for Azure cloud
        services as well as for software development and support.
      </p>
    </div>
  );
}
